export function createConfig(options = {}) {
    return {
        origin: options.origin ?? 'https://auth.farcaster.xyz'
    };
}
